//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';

import constant from '~/const';
import extraTableConfig from './extraTableConfig';

export default {
  props: {
    row: { type: [Array, Object], default: () => [] },
    innerDefault: { type: Number, default: 0 },
  },

  data() {
    return {
      extraTableConfig,
      constant,
      extraData: [...this.$props.row],
      defaultRow: {
        alias: '',
        subject: '',
        message: '',
        innerDefault: this.$props?.innerDefault,
        type: 0,
        serviceType: 0,
      },
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('settingsNotifications', [
      'language',
    ]),
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('settingsNotifications', {
      loadP2PMessagesAction: 'loadP2PMessages',
      deleteMessageAction: 'deleteMessage',
      updateMessageAction: 'updateMessage',
      createMessageAction: 'createMessage',
    }),

    isSaveEnabled(row) {
      return row.subject.length > 0 && row.message.length > 0;
    },

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      this.loader = true;
      await this.loadP2PMessagesAction(data);
      this.setGeneralProgress(false);
      this.loader = false;
    },

    createNewMessage() {
      this.extraData.push({ ...this.defaultRow });
    },

    async saveMessage(row) {
      this.confirmAction({
        text: 'Are you sure you want to update this message?',
        callback: async () => {
          this.setGeneralLoader(true);
          const body = {
            alias: row.alias,
            type: row.type,
            language: this.language,
            innerDefault: this.$props.innerDefault,
            subject: row.subject,
            message: row.message,
            serviceType: row.serviceType,
          };

          if (row.id) body.id = row.id;
          try {
            if (row.id) {
              await this.updateMessageAction(body);
            } else {
              await this.createMessageAction(body);
            }
            await this.loadData();
            this.setSuccessNotification('Message updated');
            this.setGeneralLoader(false);
          } catch (error) {
            this.setErrorNotification(error.Message);
            this.setGeneralLoader(false);
            await this.loadData();
          }
        },
      });
    },

    async deleteMessage(row) {
      if (row.id) {
        this.confirmAction({
          text: 'Are you sure you want to delete this message?',
          callback: async () => {
            this.setGeneralLoader(true);
            await this.deleteMessageAction(row.id);
            await this.loadData();
            this.setGeneralLoader(false);
            this.setSuccessNotification('Message deleted');
          },
        });
      } else {
        this.extraData.pop();
      }
    },
  },
};
